import { defaultTheme } from '@nxsys/constants/defaultConfig';

const palette = defaultTheme.theme.palette;

export const PAY_BREAKDOWN_COLORS: Record<string, string> = {
  NET_PAY: palette.primary[500],
  TAX: palette.warning[300],
  NI: palette.cyan[300],
  PENSION: palette.error[300],
  OTHER: palette.neutral[200],
  CIS_DEDUCTION: palette.primary[300],
};

const FALLBACK_COLORS = [
  palette.neutral[200],
  palette.neutral[300],
  palette.neutral[400],
  palette.neutral[500],
  palette.neutral[700],
  palette.neutral[900],
];

export const getBreakdownColor = (key: string, index: number): string => {
  return PAY_BREAKDOWN_COLORS[key] || FALLBACK_COLORS[index % FALLBACK_COLORS.length];
};
